export default "__VITE_ASSET__405f0fe3__"